module.exports = __webpack_public_path__ + "2a2170d4591d7b4db9a7799a5bd3734e.svg";